import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconFolderAddComponent } from "./med-icon-folder-add.component";

@NgModule({
  declarations: [
    MedIconFolderAddComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconFolderAddComponent,
  ],
})
export class MedIconFolderAddModule { }
